import React from 'react';

export const setAnchorElementAsNullAndStopPropagation = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
): void => {
    setAnchorEl(null);
    event.stopPropagation();
};
